import { Button, Card, Col, Divider, Form, Modal, Space, Spin, Radio, DatePicker, message, Tag, Upload, Image } from 'antd'
import React, { useState } from 'react'
import dayjs from 'dayjs'
import axios from 'axios'
import { CloseOutlined, SaveOutlined, InboxOutlined, FilePdfOutlined, DeleteOutlined } from "@ant-design/icons";
import { handleShowTYPE, handleShowTypeReply } from '../hook/function';
import Search from 'antd/es/input/Search';
import { ADDLETTER, baseUrlAREA, FINDLETTER, HEADERS_BASIC, baseUrlUPLOADIMAGELAWYER, GET_GATHER_IMAGE, HEADERS_UPIMAGE, LOAD_GATHER_IMAGE, UPLOAD_GATHER_IMAGE } from '../../../API/apiUrlsNew';
import Compressor from 'compressorjs';
import DeleteImage from './DeleteImage';

const { Dragger } = Upload;

function AddLetter({ open, close, loadData }) {

    const [loading, setLoading] = useState(false);
    const [postData, setPostData] = useState();
    const [form] = Form.useForm();

    const [allImg, setAllImg] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [imageData, setImageData] = useState([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [isModalDeleteImage, setIsModalDeleteImage] = useState(false);
    const token = localStorage.getItem('TOKEN');

    const handleClose = () => {
        close(false)
    }

    const getBase64 = file =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });

    const handlePreview = async file => {
        if (file.type === 'application/pdf' || file.name.endsWith('.pdf')) {
            let pdfUrl = file.url;
            if (!pdfUrl && file.originFileObj) {
                pdfUrl = URL.createObjectURL(file.originFileObj);
            }
            window.open(pdfUrl, '_blank');
            return;
        }
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleChangeIMG = ({ fileList: newFileList, file }) => {
        setFileList(newFileList);
        if (file.status === 'removed') {
            setAllImg(prev => prev.filter(img => img.originalIndex !== file.uid));
        }
        if (file.status === 'done' || file.status === 'removed' || file.status === 'error') {
            setLoading(false);
        }
    };

    const compressImage = async (file, types, index) => {
        return new Promise((resolve) => {
            let quality;
            if (file.size >= 2500000) quality = 0.1;
            else if (file.size >= 2000000) quality = 0.15;
            else if (file.size >= 1500000) quality = 0.2;
            else if (file.size >= 1000000) quality = 0.3;
            else quality = 0.5;

            new Compressor(file, {
                quality: quality,
                success: (result) => {
                    const compressedFileAsFile = new File([result], file.name, { type: result.type, lastModified: Date.now() });
                    setAllImg(prev => [...prev, { imageCompressedFile: compressedFileAsFile, type: types, originalIndex: index }]);
                    setLoading(false);
                    resolve(true);
                },
                error: (err) => {
                    console.error('Compressor error:', err);
                    message.error(`ไม่สามารถบีบอัดไฟล์ "${file.name}" ได้`);
                    setLoading(false);
                    resolve(true);
                },
            });
        });
    };

    const beforeUpts = async (file, ty) => {
        const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
        if (isPdf) {
            setAllImg(prev => [...prev, { imageCompressedFile: file, type: ty, originalIndex: file.uid }]);
            return false;
        }
        if (file.size > 5000000) {
            message.warning(`ไฟล์ "${file.name}" เกิน 5MB`);
            return Upload.LIST_IGNORE;
        }
        try {
            setLoading(true);
            await compressImage(file, ty, file.uid);
            return false;
        } catch (error) {
            message.error('File processing failed.');
            return Upload.LIST_IGNORE;
        }
    };

    const loadImageForLetter = (data) => {
        setImageData([]);
        axios.get(baseUrlUPLOADIMAGELAWYER + LOAD_GATHER_IMAGE + `/${data.typeReply}/${data.id}`, { headers: HEADERS_BASIC })
            .then(res => {
                if (res.status === 200 && res.data?.length > 0) {
                    setImageData(res.data);
                }
            })
            .catch(() => { });
    };

    const handleUpLoadIMG = (resultImgs) => {
        return new Promise(async (resolve, reject) => {
            try {
                const newFormData = new FormData();
                newFormData.append('id', postData.id);
                newFormData.append('notis', postData.typeReply);

                const sortedImgs = resultImgs
                    .filter(img => img.originalIndex !== undefined)
                    .sort((a, b) => {
                        const typeDiff = a.type - b.type;
                        return typeDiff !== 0 ? typeDiff : a.originalIndex - b.originalIndex;
                    });

                for (const file of sortedImgs) {
                    newFormData.append('file', file.imageCompressedFile);
                    newFormData.append('menuType', postData.typeReply);
                    newFormData.append('imageType', file.type);
                }

                const response = await axios.post(baseUrlUPLOADIMAGELAWYER + UPLOAD_GATHER_IMAGE, newFormData, { headers: HEADERS_UPIMAGE });
                if (response.status === 200) {
                    message.success("บันทึกรูปสำเร็จ");
                    setAllImg([]);
                    setFileList([]);
                    loadImageForLetter(postData);
                    resolve(true);
                }
            } catch (error) {
                message.error("บันทึกรูปไม่สำเร็จ");
                reject(error);
            }
        });
    };

    const uploadProps = {
        name: 'file',
        multiple: true,
        accept: "image/*,.pdf",
        listType: "picture",
        fileList: fileList,
        onPreview: handlePreview,
        onChange: handleChangeIMG,
        beforeUpload: (file) => beforeUpts(file, 1),
        iconRender: (file) => {
            if (file.type === 'application/pdf' || file.name.endsWith('.pdf')) {
                return <FilePdfOutlined style={{ fontSize: '48px', color: '#ff4d4f' }} />;
            }
            return null;
        },
    };

    // console.log("postData", postData)

    const onFinish = async () => {

        // console.log("onFinish", postData)

        // const payload = {
        //     // id: datePicker,
        //     // // date: datePicker.format("YYYY-MM-DD"),
        //     // type: selectedContract.value,
        //     // company: userCompany
        // };
        if (!postData?.statusReply) {
            message.warning("กรุณาเลือกสถานะตอบกลับ")
            return
        }

        setLoading(true);

        if (allImg.length > 0) {
            try {
                await handleUpLoadIMG(allImg);
            } catch (e) {
                setLoading(false);
                return;
            }
        }

        await axios.post(baseUrlAREA + ADDLETTER, postData, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    message.success("บันทึกสำเร็จ")
                    loadData(dayjs())
                    // setTimeout(() => {
                    //     handleClose()
                    // }, 1000);
                }
            })
            .catch((error) => {
                const status = error?.res?.status;
                message.error(`ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const onChangeStatusReplyWeb = (e) => {
        form.setFieldsValue({ statusReply: null })
        setPostData(
            {
                ...postData,
                statusReplyWeb: e.target.value, // ให้ radio โชว์ค่าที่เลือก
                statusReply: e.target.value     // เขียนลง statusReply เป็น 5/6 โดยตรง
            }
        )
    }

    // console.log("postData",postData)

    const onChangeStatusReply = (e) => {
        form.setFieldsValue({ statusReplyWeb: null })
        setPostData(
            {
                ...postData,
                statusReply: e.target.value,
                statusReplyWeb: null
            }
        )
    }

    const onChangeTypeReply = (e) => {
        setPostData({ ...postData, statusReply: e.target.value })
    }

    const handleInputChange = (e) => {
        const value = e.target.value;
        // ลบ whitespace ทั้งหมด (space, tab, newline) ออกเพื่อเช็คความยาวที่แท้จริง
        const cleanValue = value.replace(/\s/g, '');

        if (cleanValue.length === 13) {
            onSearchDB(cleanValue);
        }
    };

    const handleChangeDateReply = (e) => {
        // console.log("e", e)
        setPostData({ ...postData, dateReply: e })
    };

    const onSearchDB = async (value) => {
        // console.log("value", value)
        setPostData()
        setLoading(true);

        axios.get(baseUrlAREA + `${FINDLETTER}/${value}`, { headers: HEADERS_BASIC })
            .then((res) => {
                if (res.status === 200) {
                    console.log("res data", res.data);
                    if (res.data === null) {
                        message.warning(`ไม่พบข้อมูล`);
                    } else {
                        setPostData(res.data)
                        loadImageForLetter(res.data)
                        form.setFieldsValue({
                            ...res.data,
                            dateReply: res.data?.dateReply ? dayjs(res.data?.dateReply) : null

                        })
                    }
                }
            })
            .catch((error) => {
                const status = error?.res?.status;
                const serverMsg = error?.res?.postData?.message;
                console.error("API error:", status, serverMsg || error.message);
                message.error(serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
                setPostData()
                form.setFieldsValue({
                    statusReply: null,
                    typeReply: null,
                    dateReply: null
                })
            })
            .finally(() => {
                setLoading(false);
            });


        // setTimeout(() => {
        //   setLoading(false);
        // }, 250);
    };


    return (
        <Modal title="เพิ่มจดหมาย(มือ)" open={open} closable={false} footer={[null]} width={"70%"}>
            <Spin spinning={loading} tip="กำลังโหลดข้อมูล..." size="large">
                <Col span={24} style={{ textAlign: 'end', marginBottom: 8 }}>
                    <Search
                        placeholder="ค้นหาเลข EMS"
                        enterButton
                        onSearch={onSearchDB}
                        style={{ width: "auto", borderRadius: "8px" }}
                        size="large"
                        maxLength={13}
                    />
                </Col>
                <Form
                    labelCol={{
                        span: 6,
                    }}
                    wrapperCol={{
                        span: 14,
                    }}
                    form={form}
                    onFinish={onFinish}
                >
                    <Card style={{ marginTop: 10 }}>
                        {
                            postData ?
                                <>
                                    <Col span={24} style={{ textAlign: "end" }}><Tag color={'cyan'} style={{ fontSize: '16px', padding: '4px 10px' }}><b>{handleShowTypeReply(postData?.typeReply)}</b></Tag></Col>
                                    <Divider orientation={'left'}><b>ข้อมูลลูกค้า</b></Divider>
                                    <Form.Item label="ประเภทสัญญา" style={{ margin: 0 }}>{handleShowTYPE(postData?.contractSchema)}</Form.Item>
                                    <Form.Item label="ชื่อลูกค้า" style={{ margin: 0 }}>
                                        {postData?.customerFullName} {postData?.typeReply === 1 ? `(คนค้ำ${postData?.customerTypeId})` :
                                            [2, 66].includes(postData?.typeReply) && postData?.customerTypeId === 0 ? "(ผู้เช่าซื้อ)" :
                                                [2, 66].includes(postData?.typeReply) && postData?.customerTypeId !== 0 ? `(คนค้ำ${postData?.customerTypeId})` :
                                                    postData?.typeReply === 3 && postData?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                                                        postData?.typeReply === 3 && postData?.customerTypeId !== 0 ? `(คนค้ำ${postData?.customerTypeId})` :
                                                            [4, 55, 44, 88].includes(postData?.typeReply) && postData?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                                                                [4, 55, 44, 88].includes(postData?.typeReply) && postData?.customerTypeId !== 0 ? `(คนค้ำ${postData?.customerTypeId})` :
                                                                    "-"} ({postData?.CONTNO})</Form.Item>
                                    <Form.Item label="ที่อยู่" style={{ margin: 0 }}>{postData?.ADDR} {postData?.zipcode}</Form.Item>
                                    {/* <Form.Item label="เบอร์โทร" style={{ margin: 0 }}>{postData?.customerFullName} คนค้ำที่ ({postData?.contractNo})</Form.Item> */}
                                    <Form.Item label="รอบ" style={{ margin: 0 }}>{dayjs(postData?.roundDate).format("DD-MM-YYYY")}</Form.Item>
                                    <Form.Item label="EMS ไป" style={{ margin: 0 }}>{postData?.parcelNo}</Form.Item>
                                    <Form.Item label="EMS กลับ" style={{ margin: 0 }}>{postData?.parcelNoResponse}</Form.Item>
                                    <Divider orientation={'left'}><b>การจัดเก็บข้อมูล</b></Divider>
                                    <Form.Item label="เว็บไปรษณีย์" name="statusReplyWeb" style={{ margin: 0 }}>
                                        <Radio.Group
                                            onChange={onChangeStatusReplyWeb}
                                            options={[
                                                { value: 5, label: 'ตอบกลับ' },
                                                { value: 6, label: 'ตีกลับ' }
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item label="สถานะจดหมาย" name="statusReply" style={{ margin: 0 }}>
                                        <Radio.Group
                                            onChange={onChangeStatusReply}
                                            options={[
                                                { value: 1, label: 'ตอบกลับ' },
                                                { value: 2, label: 'ตีกลับ' }
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item label="ประเภทจดหมาย" name="typeReply" style={{ margin: 0 }} rules={[{ required: true, message: "กรุณาเลือก ประเภทจดหมาย !" }]}>
                                        <Radio.Group
                                            style={{ pointerEvents: 'none' }}
                                            // onChange={onChangeTypeReply}
                                            options={[
                                                { value: 1, label: 'บอกกล่าว' },
                                                { value: 2, label: 'สิทธิซื้อรถคืน' },
                                                { value: 3, label: 'แจ้งราคาขายรถ' },
                                                { value: 4, label: 'บอกเลิก' },
                                                { value: 0, label: 'บอกเลิก(เก่า)' },
                                                { value: 66, label: 'สิทธิซื้อรถคืน(เก่า)' },
                                                { value: 88, label: 'แจ้งผลประมูล' },
                                            ]}
                                        />
                                    </Form.Item>
                                    {/* <Form.Item label="ประเภทจดหมาย(เก่า)" name="typeReply" style={{ margin: 0 }} rules={[{ required: true, message: "กรุณาเลือก ประเภทจดหมาย !" }]}>
                                        <Radio.Group
                                            style={{ pointerEvents: 'none' }}
                                            // onChange={onChangeTypeReply}
                                            options={[
                                                { value: 0, label: 'บอกเลิก(เก่า)' },
                                                // { value: 55, label: 'บอกเลิก(มือ)(เก่า)' },
                                                { value: 66, label: 'สิทธิซื้อรถคืน(เก่า)' },
                                            ]}
                                        />
                                    </Form.Item> */}
                                    <Form.Item label="ประเภทจดหมาย(มือ)" name="typeReply" style={{ margin: 0 }} rules={[{ required: true, message: "กรุณาเลือก ประเภทจดหมาย !" }]}>
                                        <Radio.Group
                                            style={{ pointerEvents: 'none' }}
                                            // onChange={onChangeTypeReply}
                                            options={[
                                                // { value: 7, label: 'บอกกล่าว(มือ)' },
                                                { value: 55, label: 'บอกเลิก(มือ)(เก่า)' },
                                                { value: 44, label: 'บอกเลิก(มือ)(ใหม่)' }
                                                // { value: 44, label: 'บอกเลิก(มือ)' }
                                            ]}
                                        />
                                    </Form.Item>
                                    <Form.Item label="วันที่จัดเก็บ" name="dateReply" style={{ margin: 0 }} rules={[{ required: true, message: "กรุณาเลือก ประเภท !" }]}>
                                        <DatePicker
                                            style={{ width: '100%' }}
                                            onChange={handleChangeDateReply}
                                            value={postData.dateReply ? dayjs(postData.dateReply) : null}
                                        />
                                    </Form.Item>
                                </>
                                :
                                <>
                                    <Divider orientation={'left'}><b>ไม่พบข้อมูล กรุณากรอกเลข EMS</b></Divider>
                                </>
                        }
                    </Card>
                    {postData && (
                        <>
                            <Divider orientation="left"><b>อัปโหลดเอกสาร</b></Divider>
                            <Form.Item label="อัปโหลดไฟล์" labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                                <Dragger {...uploadProps} style={{ padding: '20px' }}>
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined style={{ color: '#1890ff' }} />
                                    </p>
                                    <p className="ant-upload-text">คลิกหรือลากไฟล์มาวางที่นี่เพื่ออัปโหลด</p>
                                    <p className="ant-upload-hint">รองรับไฟล์รูปภาพ (jpg, png) และ PDF ขนาดไม่เกิน 5MB</p>
                                </Dragger>
                            </Form.Item>
                            {imageData.length > 0 && (
                                <>
                                    <Divider />
                                    <Form.Item label="รูปภาพ/เอกสาร" labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                            {imageData.map((e, index) => {
                                                const isPdf = e.path?.toLowerCase().endsWith('.pdf');
                                                return (
                                                    <div key={index} style={{ width: 150, height: 150, flexShrink: 0 }}>
                                                        {isPdf ? (
                                                            <div
                                                                onClick={() => window.open(`${GET_GATHER_IMAGE}/${e.path}?token=${token}`, '_blank')}
                                                                style={{
                                                                    width: 150, height: 150,
                                                                    display: 'flex', flexDirection: 'column',
                                                                    justifyContent: 'center', alignItems: 'center',
                                                                    cursor: 'pointer', backgroundColor: '#f0f0f0',
                                                                    borderRadius: '8px', border: '1px solid #d9d9d9'
                                                                }}
                                                            >
                                                                <FilePdfOutlined style={{ fontSize: '40px', color: '#ff4d4f' }} />
                                                                <span style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>คลิกเพื่อเปิด PDF</span>
                                                            </div>
                                                        ) : (
                                                            <Image
                                                                width={150}
                                                                height={150}
                                                                src={`${GET_GATHER_IMAGE}/${e.path}?token=${token}`}
                                                                alt={`รูปภาพ ${index + 1}`}
                                                                style={{ display: 'block', borderRadius: '8px', objectFit: 'cover' }}
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <Button type='primary' danger onClick={() => setIsModalDeleteImage(true)} icon={<DeleteOutlined />} style={{ marginTop: 8 }}>ลบรูป</Button>
                                    </Form.Item>
                                </>
                            )}
                        </>
                    )}
                    <Divider />
                    <Col span={24} style={{ textAlign: 'end' }}>
                        <Space>
                            <Button
                                type='primary'
                                danger
                                icon={<CloseOutlined />}
                                onClick={handleClose}
                            >
                                ปิด
                            </Button>
                            <Button
                                type='primary'
                                htmlType='submit'
                                icon={<SaveOutlined />}
                                style={{ backgroundColor: 'green' }}
                            // disabled={postData?.flagSubscribe}
                            >
                                บันทึก
                            </Button>
                        </Space>
                    </Col>
                </Form>
                {previewImage && (
                    <Image
                        wrapperStyle={{ display: 'none' }}
                        preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) => setPreviewOpen(visible),
                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                        }}
                        src={previewImage}
                    />
                )}
            </Spin>
            {isModalDeleteImage && (
                <DeleteImage
                    open={isModalDeleteImage}
                    close={setIsModalDeleteImage}
                    data={imageData}
                    setData={setImageData}
                    handleUpdate={() => { }}
                />
            )}
        </Modal >
    )
}

export default AddLetter